import { Host, Component, Prop, h } from '@stencil/core'

@Component({
  tag: 'orama-logo-icon',
  styleUrl: 'orama-logo-icon.scss',
  scoped: true,
})
export class OramaLogoIcon {
  @Prop() size = 70

  render() {
    return (
      <Host>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={this.size}
          height={this.size}
          viewBox="0 0 70 70"
          fill="none"
          aria-label="Orama Logo"
          role="img"
        >
          <g clip-path="url(#clip0_283_10066)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M68.5351 26.2601C68.5469 26.5629 68.552 26.8675 68.552 27.1737C68.552 36.7741 63.0209 45.0801 54.9771 49.0868C53.9924 50.5351 52.83 51.8819 51.4899 53.0951C51.4527 53.1256 51.4172 53.1577 51.3817 53.1899C41.382 62.132 26.0305 61.2742 17.09 51.2762C8.18674 41.3171 8.99889 26.057 18.8751 17.0996C18.9191 17.0624 18.9614 17.0252 19.0053 16.9879C28.8375 8.19634 44.3125 8.72594 51.9113 17.1944C52.1008 17.4059 52.297 17.6123 52.4933 17.8187C52.5441 17.8729 52.5948 17.927 52.6456 17.9811C52.676 18.0133 52.7048 18.0471 52.7353 18.0793C52.7454 18.0911 52.7573 18.103 52.7674 18.1165C52.7962 18.1487 52.8232 18.1791 52.852 18.2113C52.8622 18.2231 52.874 18.2349 52.8841 18.2468C52.9146 18.2823 52.9468 18.3179 52.9772 18.3534C52.984 18.3618 52.9907 18.3686 52.9975 18.3771C53.0364 18.4228 53.0737 18.4684 53.1126 18.5141C53.1143 18.5158 53.1143 18.5158 53.116 18.5175C53.1515 18.5598 53.187 18.6038 53.2225 18.6478C53.2327 18.6596 53.2429 18.6732 53.253 18.685C53.2801 18.7172 53.3055 18.751 53.3325 18.7831C53.3444 18.7984 53.3562 18.8136 53.3681 18.8288C53.3934 18.861 53.4171 18.8914 53.4425 18.9236C53.4544 18.9388 53.4662 18.954 53.478 18.9693C53.5034 19.0031 53.5305 19.0369 53.5559 19.0708C53.566 19.0843 53.5762 19.0962 53.5846 19.1097C53.6185 19.1554 53.654 19.2011 53.6878 19.2484C53.698 19.262 53.7065 19.2755 53.7166 19.2874C53.967 19.6325 54.2056 19.9895 54.4272 20.355C57.8028 25.4631 57.0126 32.4122 52.3123 36.6151C52.2716 36.6506 52.2327 36.6878 52.1938 36.7234C47.0282 41.2342 39.1756 40.7588 34.5903 35.632C34.5548 35.5914 34.5176 35.5525 34.482 35.5153C29.9712 30.3496 30.4466 22.4971 35.5734 17.9118C35.5869 17.8999 35.5987 17.8881 35.6123 17.8762C38.1655 15.609 41.6967 14.4618 45.1111 14.6192C45.859 14.653 46.5781 14.7494 47.26 14.9C42.6239 12.0389 36.5361 11.1235 30.6852 12.3908C26.3892 13.3231 22.9308 16.5159 21.6973 20.7357C19.5214 28.167 21.1186 36.522 26.6633 42.7181C26.7107 42.7722 26.7614 42.8247 26.8105 42.8755C35.3602 52.2643 49.9062 53.0325 59.3933 44.5421C59.4474 44.493 59.5015 44.4439 59.5523 44.3932C68.8667 35.9095 69.6924 21.5208 61.4084 12.0304C61.1902 11.7343 60.9651 11.4484 60.735 11.1692C48.9604 -3.43781 25.8461 -3.21954 12.0885 8.91883C12.0326 8.96451 11.9768 9.01188 11.921 9.06264C-2.45083 21.915 -3.6843 43.9786 9.16302 58.3521C9.16471 58.3538 9.1664 58.3572 9.16979 58.3589C21.9866 72.6918 43.9656 73.9574 58.3425 61.2217C58.3865 61.1845 58.4288 61.1473 58.4728 61.1101C68.5571 52.0867 71.667 38.4221 68.5351 26.2601Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_283_10066">
              <rect width="70" height="70" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Host>
    )
  }
}
